import React from 'react';
import { segmentInactiveClass } from './challengeWireFormStyles';

export default function SegmentedControl({ options, value, onChange, className }) {
	return (
		<div
			className={`inline-flex flex-wrap items-center rounded-xl border border-gray-300 dark:border-dark-border bg-gray-100 dark:bg-dark-bg p-1${className ? ` ${className}` : ''}`}
			role="tablist"
		>
			{options.map((opt) => {
				const active = opt.value === value;
				return (
					<button
						key={opt.value}
						type="button"
						role="tab"
						aria-selected={active}
						onClick={() => onChange(opt.value)}
						className={`inline-flex min-h-[40px] items-center px-4 py-2 text-sm font-medium rounded-lg transition ${
							active
								? 'bg-white dark:bg-dark-card text-gray-900 dark:text-dark-text shadow-sm'
								: segmentInactiveClass
						}`}
					>
						{opt.label}
						{opt.badge > 0 && (
							<span className="ml-2 inline-flex flex-shrink-0 h-5 w-5 items-center justify-center rounded-full bg-blue-600 text-[10px] font-bold leading-none text-white">
								{opt.badge > 9 ? '9+' : opt.badge}
							</span>
						)}
					</button>
				);
			})}
		</div>
	);
}
